<template>
    <order-form v-if="!loading && order" :order="order"></order-form>
</template>

<script>
  import OrderForm from "@/components/order/form/OrderForm";
  import Order from "@/models/Order";
  import OrderRetrieve from '../../helpers/OrderRetrieve';

  export default {
      name: 'OrderEdit',
      components: {OrderForm},
      props: ['order_id'],
      data() {
        return {
          loading: true,
          order: null
        }
      },
      methods: {
        init() {
            this.loading = true;
            return this.fetch().then(() => {
                return this.populate().then(() => {
                    this.loading = false;
                });
            });
        },
        fetch() {
            let handler = new OrderRetrieve(+(this.order_id));
            return handler.fetch();
          /*return Promise.all([
              Order.api().retrieve(this.order_id),
              OrderContact.api().fetch({order_id: this.order_id}),
              OrderLocation.api().fetch({order_id: this.order_id}),
              OrderItem.api().fetch({order_id: this.order_id}),
          ]);*/
        },
        populate() {
            return new Promise(resolve => {
                this.order = Order.query().where('id', +(this.order_id)).with([
                    'order_contacts.contact',
                    'order_locations.location',
                    'order_notes.note',
                    'order_items.insulation_cut',
                ]).first();
                return resolve(this.order);
            })
        },
      },
      created() {
        this.init();
      }
	}
</script>